import { Row } from '@tanstack/react-table';
import {
  DisplayPreArrivalFormField,
  PreArrivalFormFields,
} from 'pages/automations/preArrivalForm/PreArrivalFormTab.types';
import CheckboxField from 'components/forms/checkboxField/CheckboxField';

const StatusCell = ({ row }: { row: Row<DisplayPreArrivalFormField> }) => {
  const { uid, id, name } = row.original;

  const isCustomField = id === PreArrivalFormFields.CUSTOM;
  const isNewCustomField = !row.original.uid && isCustomField;

  if (isNewCustomField) {
    return (
      <CheckboxField name={`newCustomFields[${name.toLowerCase()}].isActive`} />
    );
  }

  return (
    <CheckboxField
      name={`${isCustomField ? `customFields.${uid}` : id}.isActive`}
    />
  );
};

export default StatusCell;
